/** @enum {number} */
const FlipOrientation = Object.freeze({
    HORIZONTAL: 0,
    VERTICAL: 1
})

export default FlipOrientation;